import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";

export default function BranchSelect({ value, options, onChange }){
  return (
    <FormControl variant="outlined" size="small" style={{minWidth: 240}}>
      <InputLabel>Sucursal</InputLabel>
      <Select
        label="Sucursal"
        value={value}
        onChange={(e)=>onChange(e.target.value)}
      >
        {(options||[]).map(b=>(
          <MenuItem key={b.id} value={b.id}>{b.nombre}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
